import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { childrenShape } from '@bibliocommons/bc-prop-types';

import PinchHandler from './PinchHandler';

import './PanZoom.scss';

const PanZoom = ({ children, className, handleUpdate, height, maxScale, scale, x, y, width }) => {
  const heightToWidthRatio = (height / width) * 100;
  const containerStyle = {
    paddingTop: `${heightToWidthRatio.toFixed(2)}%`
  };

  const contentStyle = {
    transform: `scale(${scale}) translateY(${y}px) translateX(${x}px)`
  };

  return (
    <PinchHandler maxScale={maxScale} onUpdate={handleUpdate} scale={scale} x={x} y={y}>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <div className={cn('cp-pan-zoom', className)} tabIndex={0}>
        <div className="pan-zoom-container" style={containerStyle}>
          <div className="pan-zoom-inner">
            <div className="pan-zoom-content" style={contentStyle}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </PinchHandler>
  );
};

PanZoom.propTypes = {
  children: childrenShape,
  className: PropTypes.string,
  handleUpdate: PropTypes.func.isRequired,
  height: PropTypes.number.isRequired,
  maxScale: PropTypes.number,
  scale: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};

export default PanZoom;
